<?xml version="1.0" encoding="utf-8"?>
<svg version="1.1" id="fp-classic-reports" xmlns="http://www.w3.org/2000/svg" x="0px"
     y="0px"
     viewBox="5 2 20 26" enable-background="new 0 0 30 30" xml:space="preserve">
<path fill="currentColor" d="M21,5H9C7.9,5,7,5.9,7,7v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V7C23,5.9,22.1,5,21,5z M20,20H10v-2h10V20z
	 M20,16H10v-2h10V16z M20,12H10v-2h10V12z"/>
</svg>
